import React from "react";
import "./VideoDownloaderCard.css";

const VideoDownloaderCard = () => {
  return (
    <section className="video-downloader-card">
      <div className="video-downloader__container">
        <div className="video-downloader__content">
          <img
            src="/assets/appImg.png"
            alt="Video Downloader App Icon"
            className="video-downloader__icon"
            width="86"
            height="86"
          />
          <div className="video-downloader__text">
            <h2 className="video-downloader__title">All Video Downloader</h2>
            <p className="video-downloader__description">
              Don't miss out - get All Video Downloader App today and start
              enjoying your videos offline!
            </p>
          </div>
        </div>
        <div className="video-downloader__install">
          <h3 className="video-downloader__install-title">
            Install Mobile App on
          </h3>
          <div className="video-downloader__stores">
            <a
              href="https://play.google.com/store/apps/details?id=com.hdvideodownloader.downloaderapp"
              className="video-downloader__store-link"
              aria-label="Download on App Store"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/assets/googlePlay.png"
                alt=""
                className="video-downloader__store-image"
                width="208"
                height="60"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoDownloaderCard;
